import React from 'react';
import { ReactComponent as ReactSVG } from '../../assets/svg/React.svg';

const ReactIcon = ({ color = 'rgb(230,230,230)', size = 25, className = 'React-icon' }) => {
  return (
    <ReactSVG
      className={className}
      style={{  }}
    />
  );
};

export default ReactIcon;